import React, { useState } from 'react';

import Cropper from 'react-cropper';

import '@app/scss/localCommon/components/imageCropper.scss';
import listenerForBrowser from '@app/components/Pages/listenerForBrowser';

import '../../../../node_modules/cropperjs/dist/cropper.css';

const ImageCropper = (
	{image, setImage, initFile, setCroppedImage, uploadFile, setCropperModalOpen, aspectRatio, cropperButton = false}
	) => {
	const [cropper, setCropper] = useState<any>();
	const [base64Data, setBase64Data] = React.useState();
	const [isMobile, setIsMobile] = React.useState(false);

	React.useEffect(() => {
		const mql = window.matchMedia('screen and (max-width: 768px)');

		const listenerFunc = () => {
			if (mql.matches) {
				setIsMobile(true);
			} else {
				setIsMobile(false);
			}
		};
		listenerFunc();
		listenerForBrowser(mql, listenerFunc);
	}, []);

	const reader = new FileReader();
	reader.readAsDataURL(image);

	reader.onloadend = function () {
		// @ts-ignore
		setBase64Data(reader.result);
	};

	const getCropData = () => {
		if (typeof cropper !== 'undefined') {

			fetch(`${cropper.getCroppedCanvas().toDataURL('image/jpeg')}`)
				.then(res => res.blob())
				.then((blob) => {
					const croppedFile = new File([blob], initFile.name, { type: initFile.type, lastModified: Date.now() });
					setCroppedImage({croppedImage: croppedFile});
					const url = window.URL.createObjectURL(croppedFile);

					uploadFile({
						file: croppedFile,
						filename: 'file',
						headers: {'No-Relation': 'true'},
						method: 'post',
						extension: 'jpg'
					});
				});
			setCropperModalOpen({cropperModalOpen: false});
		}
	};

	return (
		<div className="image-cropper">
			<h3 className="image-cropper-title">Rotate image if needed. <br />Upload image when done.</h3>

			{isMobile &&
				<div className="text-center">
					<button
						onClick={getCropData}
						className="btn btn-primary"
					>
						Upload Image
					</button>
				</div>
			}
			<div className="image-cropper-wrapper">
				<Cropper
					style={{ height: 400, width: '100%' }}
					restore={false}
					zoomTo={0}
					initialAspectRatio={aspectRatio}
					preview=".img-preview"
					src={base64Data}
					viewMode={0}
					dragMode={'none'}
					rotatable={true}
					guides={false}
					minCropBoxHeight={50}
					minCropBoxWidth={50}
					background={false}
					zoomable={false}
					center={true}
					highlight={false}
					zoomOnTouch={false}
					zoomOnWheel={false}
					responsive={true}
					autoCrop={false}
					autoCropArea={1}
					checkOrientation={false} // https://github.com/fengyuanchen/cropperjs/issues/671
					onInitialized={(instance) => {
						setCropper(instance);
					}}
				/>
			</div>

			<div className="image-cropper-btns">
				{/*<button onClick={() => cropper.setData({y: 40})}>*/}
				{/*	/!*cropper.getContainerData().height / 2*!/*/}
				{/*	reposit*/}
				{/*</button>*/}
				{!isMobile &&
					<button
						className="btn btn-secondary"
						onClick={() => setCropperModalOpen({cropperModalOpen: false})}
					>
						Cancel
					</button>
				}

				{!isMobile &&
					<button
						onClick={getCropData}
						className="btn btn-primary"
					>
						Upload Image
					</button>
				}
				<div className="btns-nav">
					<button onClick={() => cropper.rotate(90)} className="btn-nav btn-rotate">
						<div>
							<img src={require('@app/images/rotate-arrow.svg')} alt="rotate"/>
							<br/>
							Rotate
						</div>
					</button>
					{isMobile &&
						<button
							onClick={() => setCropperModalOpen({cropperModalOpen: false})} className="btn-nav btn-adjust">
							<div>
								<img src={require('@app/images/close_dark_wide.svg')} alt="adjust"/>
								<br/>
								Cancel
							</div>
						</button>
					}
					{cropperButton &&
						<button
							onClick={() => {
								cropper.setDragMode('crop');
								cropper.reset();
								cropper.crop();
							}} className="btn-nav btn-adjust">
							<div>
								<img src={require('@app/images/adjust-icon.svg')} alt="adjust"/>
								<br/>
								Crop
							</div>
						</button>
					}
				</div>

			</div>
		</div>
	);
};

export default ImageCropper;
